import { DefaultSecondaryButton } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';
import { useModals } from '@frontend/modal';
import { Transaction } from '@frontend/transaction/types';
import { ReactElement } from 'react';

import { CancelTransactionModal } from '../cancel-transaction-modal/cancel-transaction-modal';

interface CancelTransactionActionProps {
    transaction: Transaction;
    canRender?: boolean;
    size?: 'sm' | 'md' | 'lg';
    onSubmitCallback?: () => void;
}

interface CompactHeaderActionItem {
    label: ReactElement;
    onClick: () => void;
}

const createOpenCancelModalHandler = (openModal: ReturnType<typeof useModals>['openModal'], transaction: Transaction, onSubmitCallback?: () => void) => {
    return () => {
        openModal(
            `cancel-transaction-modal-${transaction.id}`,
            () => (
                <CancelTransactionModal
                    transaction={transaction}
                    onSubmitCallback={onSubmitCallback}
                />
            ),
            {},
            { className: 'w-[520px]' }
        );
    };
};

export const CancelTransactionActionButton = (props: CancelTransactionActionProps) => {
    const { openModal } = useModals();

    if (props.canRender === false) return null;

    return (
        <DefaultSecondaryButton
            text={CommonMessage.BUTTONS.CANCEL}
            onClick={createOpenCancelModalHandler(openModal, props.transaction, props.onSubmitCallback)}
            size={props.size ?? 'sm'}
        />
    );
};

export const getCancelTransactionCompactActionItem = (props: {
    transaction: Transaction;
    canRender?: boolean;
    openModal: ReturnType<typeof useModals>['openModal'];
    onSubmitCallback?: () => void;
}): CompactHeaderActionItem | null => {
    if (props.canRender === false) return null;

    return {
        label: CommonMessage.BUTTONS.CANCEL,
        onClick: createOpenCancelModalHandler(props.openModal, props.transaction, props.onSubmitCallback)
    };
};
